module.exports = __webpack_public_path__ + "img/light-mud-decal-06.336c01ec.png";